import { BrandMark } from "@/components/wizard/brand-mark";
import { Shell } from "@/components/wizard/shell";

export function WelcomeScreen({ onStart }: { onStart: () => void }) {
	return (
		<Shell>
			<div className="fade-up max-w-xl text-center">
				<BrandMark />
				<h1 className="mt-6 font-display text-3xl leading-tight text-foreground sm:text-5xl">
					Vamos preparar a sua consulta
				</h1>
				<p className="mt-5 text-xl text-muted-foreground">
					São algumas perguntas rápidas, uma de cada vez. Leva uns 3 minutos e você já chega com
					tudo pronto.
				</p>
				<button
					type="button"
					onClick={onStart}
					className="mt-10 rounded-full bg-primary px-10 py-4 text-xl font-semibold text-primary-foreground shadow-control transition hover:bg-primary-hover"
				>
					Começar
				</button>
			</div>
		</Shell>
	);
}
